<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="goBack()">
        <ion-icon name="arrow-back" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Topic Details</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <ion-spinner></ion-spinner>
    <p>Loading topic...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !isLoading" class="error-container">
    <ion-card color="danger">
      <ion-card-content>
        <p>{{ error }}</p>
        <ion-button fill="outline" (click)="loadTopic()" color="light">
          Try Again
        </ion-button>
      </ion-card-content>
    </ion-card>
  </div>

  <!-- Topic Details -->
  <div *ngIf="topic && !isLoading && !error" class="topic-details">
    <!-- Header Card -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>{{ topic.topicTitle }}</ion-card-title>
        <ion-card-subtitle>
          <ion-chip [color]="getConfidenceColor(topic.confidence)" size="small">
            <ion-icon name="analytics" size="small"></ion-icon>
            {{ getConfidenceLabel(topic.confidence) }} Confidence ({{
              topic.confidence * 100 | number: "1.0-0"
            }}%)
          </ion-chip>
        </ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <div class="description-section">
          <h4>Description</h4>
          <p>{{ topic.topicDescription }}</p>
        </div>

        <div class="context-section">
          <h4>Context</h4>
          <div class="context-content">
            <p>{{ topic.context }}</p>
          </div>
        </div>

        <div class="metadata-section">
          <ion-text color="medium">
            <small> Created {{ formatDateTime(topic.createdAt) }} </small>
          </ion-text>
        </div>
      </ion-card-content>
    </ion-card>

    <!-- Related Conversation -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>Related Conversation</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <a
          [href]="getConversationUrl(topic.conversationId)"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ion-item>
            <ion-label>
              <h3>{{ getConversationTitle() }}</h3>
              <p>View conversation details</p>
            </ion-label>
            <ion-icon name="open" slot="end"></ion-icon>
          </ion-item>
        </a>
      </ion-card-content>
    </ion-card>

    <!-- Related Insight -->
    <ion-card *ngIf="topic.insight">
      <ion-card-header>
        <ion-card-title>Related Insight</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <a [routerLink]="getInsightUrl(topic.insight.id)">
          <ion-item>
            <ion-label>
              <h3>{{ topic.insight.category }}</h3>
              <p>
                Language: {{ topic.insight.language }}
                <span *ngIf="topic.insight.projectId">
                  • Project ID: {{ topic.insight.projectId }}</span
                >
              </p>
            </ion-label>
            <ion-icon name="chevron-forward" slot="end"></ion-icon>
          </ion-item>
        </a>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
